import { left, right } from 'fp-ts/Either';

import { httpClientFunction } from 'domain/types';
import { JsonWidgetGaugeRange, WidgetConfigurationField, WidgetOptionConfigurationField } from 'domain/entity/widget';
import CreateWidgetClient from 'use-case/widgets/create/createWidgetClient';
import CreateWidgetCriteria from 'use-case/widgets/create/createWidgetCriteria';
import BasicEntity from 'domain/entity/basicEntity';
import { JsonChartLimit } from 'adapter/out/client/widgets/data/mappers/common';

export default (httpClient: httpClientFunction, baseUrl: string): CreateWidgetClient => (criteria: CreateWidgetCriteria) =>
    httpClient(`${baseUrl}/dashboards/dashboards/${criteria.dashboardId}/widgets`, {
        method: 'POST',
        body: JSON.stringify(asJsonNewWidget(criteria)),
        headers: { 'Content-Type': 'application/json' },
    })
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then((json: BasicEntity) => ({ id: json.id }))
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));

export const asJsonNewWidget = (criteria: CreateWidgetCriteria): JsonNewWidget => ({
    name: criteria.name,
    settings: {
        type: criteria.type as string,
        options: criteria.optionFields.map((field: WidgetOptionConfigurationField) => ({ key: field.key, value: field.value })),
    },
    configuration: {
        feature: '',
        preset: criteria.presetKey,
        fields: criteria.configurationFields.map((field: WidgetConfigurationField) => ({ key: field.key, value: field.value })),
    },
});

type JsonNewWidget = {
    name: string;
    settings: {
        type: string;
        options: {
            key: string;
            value: string | JsonWidgetGaugeRange[] | JsonChartLimit[];
        }[];
    };
    configuration: {
        feature: '';
        preset: string;
        fields: {
            key: string;
            value: string;
        }[];
    };
};
